export const COUNTDOWN_TYPE = Object.freeze({
	DURATION: 'duration',
	DATE: 'date',
})

export const BUTTON_STATE = Object.freeze({
	ENABLED: 'enabled',
	DISABLED: 'disabled',
})
